import React from 'react'

function DashboardAbout() {
  return <>
  
  <div>Bu Sayfa private ABOUT Sayfası</div>
  </>
}

export default DashboardAbout